import { Vital } from "requests";

export const generateVitalsData = (vitals: Vital[]) => {
  if (vitals && vitals?.length > 0) {
    return vitals?.reduce(
      (acc: any, el) => {
        return acc.map((accEl: any) => {
          if (accEl.name === "HR") {
            accEl.val = [
              ...accEl.val,
              {
                vitalId: el._id || el.fakeId,
                timeMonitoring: el.timeMonitoring,
                value: el.heartRate
              }
            ];
          }
          if (accEl.name === "RR") {
            accEl.val = [
              ...accEl.val,
              {
                vitalId: el._id || el.fakeId,
                timeMonitoring: el.timeMonitoring,
                value: el.respiratoryRate
              }
            ];
          }

          if (accEl.name === "SpO2") {
            accEl.val = [
              ...accEl.val,
              {
                vitalId: el._id || el.fakeId,
                timeMonitoring: el.timeMonitoring,
                value: el.pulseOximetry
              }
            ];
          }

          if (accEl.name === "End-Tidal CO2") {
            accEl.val = [
              ...accEl.val,
              {
                vitalId: el._id || el.fakeId,
                timeMonitoring: el.timeMonitoring,
                value: el.endTidal
              }
            ];
          }
          if (accEl.name === "SBP") {
            accEl.val = [
              ...accEl.val,
              {
                vitalId: el._id || el.fakeId,
                timeMonitoring: el.timeMonitoring,
                value: el.systolicBloodPressure
              }
            ];
          }

          if (accEl.name === "MBP") {
            accEl.val = [
              ...accEl.val,
              {
                vitalId: el._id || el.fakeId,
                timeMonitoring: el.timeMonitoring,
                value: el.meanBloodPressure
              }
            ];
          }

          if (accEl.name === "DBP") {
            accEl.val = [
              ...accEl.val,
              {
                vitalId: el._id || el.fakeId,
                timeMonitoring: el.timeMonitoring,
                value: el.diastolicBloodPressure
              }
            ];
          }

          return accEl;
        });
      },
      [
        {
          name: "HR",
          _id: 0,
          mainColor: "#86A3F6",
          color: "#E7ECFD",
          val: []
        },
        {
          name: "RR",
          _id: 1,
          mainColor: "#48BB78",
          color: "#F0FFF4",
          val: []
        },
        {
          name: "SpO2",
          _id: 2,
          mainColor: "#ECC94B",
          color: "#FFFFF0",
          val: []
        },
        {
          name: "End-Tidal CO2",
          _id: 3,
          mainColor: "#ED8936",
          color: "#FFFAF0",
          val: []
        },
        {
          name: "SBP",
          _id: 4,
          mainColor: "#F56565",
          color: "#FFF5F5",
          val: []
        },
        {
          name: "MBP",
          _id: 5,
          mainColor: "#9F7AEA",
          color: "#FAF5FF",
          val: []
        },
        {
          name: "DBP",
          _id: 6,
          mainColor: "#ED64A6",
          color: "#FFF5F7",
          val: []
        }
      ]
    );
  }

  return [];
};
